/* v0.3b: filters in de zijbalk werken direct; open/dicht en focus blijven behouden na verversen. */
(function () {
  'use strict';
  var state = null, focusId = null, timer = null;
  function snapshot(form) {
    state = {};
    form.querySelectorAll('details[data-facet]').forEach(function (d) { state[d.dataset.facet] = d.open; });
    var a = document.activeElement;
    focusId = a && form.contains(a) ? a.id : null;
  }
  function restore() {
    var form = document.querySelector('form[data-filter-auto]');
    if (!form || !state) return;
    form.querySelectorAll('details[data-facet]').forEach(function (d) {
      if (Object.prototype.hasOwnProperty.call(state, d.dataset.facet)) d.open = state[d.dataset.facet];
    });
    if (focusId) { var el = document.getElementById(focusId); if (el) el.focus({ preventScroll: true }); }
    state = null; focusId = null;
  }
  function submit(form) {
    snapshot(form);
    if (form.requestSubmit) form.requestSubmit(); else form.submit();
  }
  document.addEventListener('change', function (e) {
    var form = e.target.closest && e.target.closest('form[data-filter-auto]');
    if (!form) return;
    clearTimeout(timer);
    if (e.target.type === 'number') { timer = setTimeout(function () { submit(form); }, 400); return; }
    submit(form);
  });
  function watch() {
    var section = document.querySelector('[data-collection-section]');
    if (!section || section.dataset.aksWatch) return;
    section.dataset.aksWatch = '1';
    new MutationObserver(function () { restore(); }).observe(section, { childList: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
  document.addEventListener('shopify:section:load', watch);
})();

/* v0.3d: 'Toon alle' bij lange filterlijsten; blijft open na verversen. */
(function () {
  'use strict';
  var open = {};
  function apply() {
    document.querySelectorAll('[data-facet-more]').forEach(function (b) {
      var d = b.closest('details[data-facet]');
      var on = !!(d && open[d.dataset.facet]);
      d && d.classList.toggle('is-more', on);
      b.setAttribute('aria-expanded', on ? 'true' : 'false');
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-facet-more]');
    if (!b) return;
    var d = b.closest('details[data-facet]');
    if (!d) return;
    open[d.dataset.facet] = !open[d.dataset.facet];
    apply();
  });
  var section = document.querySelector('[data-collection-section]');
  if (section) new MutationObserver(apply).observe(section, { childList: true, subtree: true });
})();

/* v0.4: reviews heen en weer schuiven. */
(function () {
  'use strict';
  function init(root) {
    if (root.dataset.ready) return; root.dataset.ready = '1';
    var track = root.querySelector('[data-aks-rv-track]');
    var prev = root.querySelector('[data-aks-rv-prev]');
    var next = root.querySelector('[data-aks-rv-next]');
    if (!track) return;
    function step() { var c = track.querySelector('.aks-rv-card'); return c ? c.getBoundingClientRect().width + 18 : track.clientWidth; }
    function update() {
      if (prev) prev.disabled = track.scrollLeft < 4;
      if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    }
    prev && prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next && next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }
  function all(scope) { (scope || document).querySelectorAll('[data-aks-rv]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { all(); }); else all();
  document.addEventListener('shopify:section:load', function (e) { all(e.target); });
})();

/* v0.4: footerkolommen op mobiel uitklappen. */
document.addEventListener('click', function (e) {
  var h = e.target.closest && e.target.closest('.akf-col:not(.akf-contact) h3');
  if (!h || window.innerWidth > 580) return;
  var col = h.parentElement;
  col.classList.toggle('is-open');
  h.setAttribute('aria-expanded', col.classList.contains('is-open') ? 'true' : 'false');
});
